import React, { useState } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Button from '../Button';
import { withStyles } from '@material-ui/core/styles';
import EmailForm from './EmailForm';
import NewPassForm from './NewPassForm';
import Snackbar from '../Snackbar';
import authErrorMessages from '../../common/error/Authentication';
import { Auth } from 'aws-amplify';
import Slide from '@material-ui/core/Slide';

const styles = themes => ({
  root: {
    width: 400,
    minHeight: 250,
    display: 'grid',
    padding: 10,
    gridTemplateRows: '2fr 5fr 1fr',
  },
  dialogTitle: {
    gridRow: 1,
  },
  stepContent: {
    gridRow: 2,
    justifySelf: 'center',
    alignSelf: 'stretch',
  },
  action: {
    gridRow: 3,
  },
  success: {
    textAlign: 'center',
  },
  icon: {
    fontSize: 72,
  },
});

const Transition = props => {
  return <Slide direction="down" {...props} />;
};

const ForgotPassDialog = ({ classes, onClose: handleClose, ...rest }) => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPass, setNewPass] = useState('');
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ show: false, content: '', type: 'info' });

  const getSteps = () => ['Get user email', 'Set new password'];
  const getStepContent = step => {
    switch (step) {
      case 0:
        return <EmailForm email={email} setEmail={setEmail} />;
      case 1:
        return <NewPassForm code={code} setCode={setCode} newPass={newPass} setNewPass={setNewPass} />;
      default:
        return 'Error with stepper.';
    }
  };
  const steps = getSteps();

  const nextStep = () => {
    setActiveStep(activeStep + 1);
  };

  const sendCode = () => {
    Auth.forgotPassword(email)
      .then(data => {
        setMessage({ show: true, type: 'info', content: 'Check your email for the code.' });
        nextStep();
      })
      .catch(err => {
        setMessage({ show: true, content: authErrorMessages(err.code), type: 'error' });
      })
      .finally(() => setLoading(false));
  };

  const setNewPassword = () => {
    Auth.forgotPasswordSubmit(email, code, newPass)
      .then(data => {
        nextStep();
        setTimeout(() => {
          closeDialog();
        }, 2000);
      })
      .catch(err => {
        setMessage({ show: true, content: authErrorMessages(err.code), type: 'error' });
        setLoading(false);
      });
  };

  const handleAction = e => {
    e.preventDefault();
    setLoading(true);
    if (!loading) {
      switch (activeStep) {
        case 0:
          sendCode();
          break;
        case 1:
          setNewPassword();
          break;
        default:
          setMessage({ show: true, content: 'Uh oh.. Something super bad happened. Refresh the browser' });
          console.log('Something went wrong with handling of ForgotPass button.');
      }
    }
  };

  const handleMessageClose = () => {
    setMessage({ ...message, show: false });
  };

  const closeDialog = () => {
    setMessage({ ...message, show: false });
    setEmail('');
    setCode('');
    setNewPass('');
    setActiveStep(0);
    handleClose();
    setLoading(false);
  };

  return (
    <Dialog TransitionComponent={Transition} onClose={closeDialog} {...rest}>
      <form onSubmit={handleAction} className={classes.root}>
        <DialogTitle className={classes.dialogTitle}>Forgot Password</DialogTitle>
        <div className={classes.stepContent}>
          {activeStep === steps.length ? (
            <div className={classes.success}>
              <CheckCircleIcon color="primary" classes={{ root: classes.icon }} />
              <Typography variant="title">Password changed!</Typography>
            </div>
          ) : (
            getStepContent(activeStep)
          )}
        </div>
        <Button
          color="secondary"
          variant="contained"
          disabled={loading}
          type="submit"
          classes={{ root: classes.action }}
        >
          {activeStep === 0 ? 'Send reset email' : 'Save new password'}
        </Button>
      </form>
      <Snackbar
        variant={message.type}
        open={message.show}
        onClose={handleMessageClose}
        autoHideDuration={5000}
        message={message.content}
      />
    </Dialog>
  );
};

export default withStyles(styles)(ForgotPassDialog);
